import React from "react";
import SelfReferralConfigRow from "./SelfReferralConfigRow";
import "../SharedComponents/Styles/SharedGenericStyles.css";

export const SELF_REFERRAL_SETTING_DESCRIPTIONS = [
    "Self Referral Delegated Authority Configuration for IA",
    "Self Referral Delegated Authority Configuration for Treatment",
    "SelfReferralRedirectOnOff",
];

export const isSelfReferralSetting = setting =>
    SELF_REFERRAL_SETTING_DESCRIPTIONS.some(text =>
        (setting.SettingDescription ?? setting.SettingKey ?? "").startsWith(text)
    );

const SelfReferralConfiguration = ({ api, settings, clientID }) => {
    return (
        <div className="clientConfigurationDiv">
            <h2 className="clientConfigHeader">Self Referral Configuration</h2>

            {settings?.length !== 0 ? (
                <div className="clientConfigTable">
                    {settings.map(setting => (
                        <SelfReferralConfigRow
                            api={api}
                            key={"" + clientID + "_" + setting.SettingKey}
                            setting={setting}
                            clientID={clientID}
                        />
                    ))}
                </div>
            ) : (
                <p className="configEmptyMessage">
                    No Self Referral settings available.
                </p>
            )}
        </div>
    );
};

export default SelfReferralConfiguration;
